import { RelatedProductType } from '../models/related-products.models';

export const RECOMMENDED_TYPES_PRODUCT_DETAIL: RelatedProductType[] = [
    'completatulook_yoda',
    'frecuently_bought_together',
    'other_you_may_like',
    'top_sales',
];
